// Worksnip thread icon — two overlapping speech bubbles, the front one carrying
// text lines (a conversation). Used everywhere threads are represented so the
// brand reads consistently. Lucide-compatible API (size / strokeWidth / className,
// currentColor stroke) so it drops in wherever a lucide icon was used.

interface Props {
  size?: number;
  className?: string;
  strokeWidth?: number;
}

export function ThreadIcon({ size = 16, className, strokeWidth = 2 }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* Back bubble (top-right), tail pointing down. */}
      <path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1" />
      {/* Front bubble (bottom-left) with a down-left tail + two text lines. */}
      <path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2z" />
      <line x1="5" y1="5" x2="11" y2="5" />
      <line x1="5" y1="7.5" x2="11" y2="7.5" />
    </svg>
  );
}

export default ThreadIcon;
